var _rect, _rect2, _g, _path, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareerHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 70,
    viewBox: "0 0 116 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.0000915527,
    width: 116,
    height: 70,
    rx: 7,
    fill: "#EFDB7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6693_11592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -0.0000915527,
    width: 116,
    height: 70,
    rx: 7,
    fill: "#FEF9EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6693_11592)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6693_11592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8232 -67.6024H44.6128V137.598H69.8232V-67.6024Z",
    fill: "#CEE8E4",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6083 -67.6024H19.3979V137.598H44.6083V-67.6024Z",
    fill: "#FEBD02",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0336 -67.6024H69.8232V137.598H95.0336V-67.6024Z",
    fill: "#E9725B",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8288 49.5302C85.8701 38.1619 83.1616 22.4355 71.7793 14.4041C60.397 6.37283 44.651 9.07795 36.6098 20.4462C28.5685 31.8145 31.277 47.5409 42.6593 55.5722C54.0417 63.6036 69.7876 60.8984 77.8288 49.5302Z",
    fill: "#FEF9EF",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6693_11592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 9,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2342 31.7411C80.4643 17.9293 67.8299 8.18105 54.0144 9.96779C40.1989 11.7545 30.4341 24.3997 32.204 38.2115C33.9739 52.0233 46.6083 61.7716 60.4238 59.9848C74.2393 58.1981 84.0041 45.553 82.2342 31.7411Z",
    fill: "#FEF9EF",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6693_11592)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6693_11592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8888 21.1375C69.8888 21.1375 72.6086 20.8056 74.36 25.2183C76.6903 31.0902 74.454 34.5744 67.4292 36.3481C61.9093 37.7428 58.1504 38.0573 58.1504 38.0573",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3713 39.7718C39.3733 41.9217 33.3808 49.1481 31.0805 46.4607C29.1452 44.1993 33.5021 41.2055 34.9511 39.5931",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8888 21.1375C69.8888 21.1375 72.6086 20.8056 74.36 25.2183C76.6903 31.0902 74.454 34.5744 67.4292 36.3481C61.9093 37.7428 58.1504 38.0573 58.1504 38.0573",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8888 21.1375C69.8888 21.1375 72.6086 20.8056 74.36 25.2183C76.6903 31.0902 74.454 34.5744 67.4292 36.3481C61.9093 37.7428 58.1504 38.0573 58.1504 38.0573",
    stroke: "#F2C850",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4896 74.9107L40.3623 74.3195L46.5291 52.4603L48.6374 53.0461L42.4896 74.9107Z",
    fill: "#F2C850",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9073 77.633L51.4756 51.3531L54.7034 51.4109L53.5484 77.6626L51.9073 77.633Z",
    fill: "#F2C850",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8667 47.3771L58.8095 41.8774C58.262 41.1357 57.6192 40.4678 56.896 39.8914L52.0435 36.0216",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8667 47.3771L58.8095 41.8774C58.262 41.1357 57.6192 40.4678 56.896 39.8914L52.0435 36.0216",
    stroke: "#F2C850",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4236 20.9399C39.5258 20.9399 33.1343 27.2459 33.1343 35.038H47.4236V20.9399Z",
    fill: "#80C69F",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4683 20.9628V20.9547H47.4238V34.9977H78.3763C78.3763 27.3426 72.1836 21.1334 64.467 20.9628H64.4683Z",
    fill: "#F2C850",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4238 31.0889C49.2832 31.0889 50.7905 29.6017 50.7905 27.7672C50.7905 25.9328 49.2832 24.4456 47.4238 24.4456C45.5644 24.4456 44.0571 25.9328 44.0571 27.7672C44.0571 29.6017 45.5644 31.0889 47.4238 31.0889Z",
    fill: "white",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2386 24.4443C44.9424 24.4443 44.0571 25.6442 44.0571 27.5388C44.0571 27.8089 44.4548 28.2483 44.5161 28.4996C44.8974 28.7387 45.3496 28.8785 45.8344 28.8785C47.1977 28.8785 48.3023 27.7887 48.3023 26.4437C48.3023 25.6146 47.8814 24.8823 47.2386 24.4429V24.4443Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0801 34.9977C33.0801 45.0337 41.3116 53.155 51.4838 53.155V34.9977H33.0801Z",
    fill: "#EB4A5A",
    stroke: "#020203",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8886 53.155C69.8886 43.1189 61.6571 34.9977 51.4849 34.9977V53.155H69.8886Z",
    fill: "#B8DDE3",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4839 53.155C51.4839 63.191 59.7154 71.3123 69.8876 71.3123V53.155H51.4839Z",
    fill: "#E8F5F2",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.604 32.1114C51.2605 31.8292 51.9918 31.672 52.7627 31.672",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7671 36.7767C46.8965 36.7458 48.1426 36.5201 48.1426 36.5201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7671 36.7767C46.8965 36.7458 48.1426 36.5201 48.1426 36.5201",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3199 19.9899C56.2927 19.9604 56.2001 19.8905 56.2777 19.5412C56.3853 19.0601 56.7653 18.9096 57.4925 18.6557C58.4786 18.3117 59.3992 18.1988 60.4084 18.2458C61.4857 18.2969 62.5725 18.2364 63.6389 18.4165C64.4302 18.5508 65.2596 18.5468 66.0577 18.6328C67.3856 18.7752 68.7148 18.9459 70.025 19.22C70.7318 19.3678 71.4237 19.6715 72.1087 19.908C72.1087 19.908 72.2667 22.4046 70.6433 23.6112C70.3573 23.8235 69.5987 22.981 69.2963 22.9138C68.7638 22.7942 68.23 22.68 67.6947 22.5712C67.0097 22.4328 66.5534 22.3468 65.8697 22.6316C64.7407 23.1019 63.8064 23.2323 62.6433 22.8789C62.1163 22.719 61.7363 22.551 61.4816 22.418C61.1779 22.2594 60.8388 22.1855 60.4969 22.203C60.1728 22.2191 59.85 22.2379 59.5313 22.3159C59.0179 22.4408 58.5262 22.6599 58.0087 22.7687C57.6709 22.8399 57.2297 22.809 57.2324 22.3132L56.5542 22.2164L56.4084 21.4317L55.7847 20.8445L55.8419 20.299L56.3199 19.9899V19.9899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3201 19.9899C56.2929 19.9604 56.2003 19.8905 56.2779 19.5412C56.3855 19.0601 56.7655 18.9096 57.4927 18.6557C58.4788 18.3117 59.3994 18.1988 60.4086 18.2458C61.4859 18.2969 62.5727 18.2364 63.6391 18.4165C64.4304 18.5508 65.2598 18.5468 66.0579 18.6328C67.3858 18.7752 68.715 18.9459 70.0252 19.22C70.732 19.3678 71.4239 19.6715 72.1089 19.908C72.1089 19.908 72.2669 22.4046 70.6435 23.6112C70.3575 23.8235 69.5989 22.981 69.2966 22.9138C68.764 22.7942 68.2302 22.68 67.6949 22.5712C67.0099 22.4328 66.5536 22.3468 65.8699 22.6316C64.7409 23.1019 63.8066 23.2323 62.6435 22.8789C62.1165 22.719 61.7365 22.551 61.4818 22.418C61.1781 22.2594 60.839 22.1855 60.4972 22.203C60.173 22.2191 59.8502 22.2379 59.5315 22.3159C59.0181 22.4408 58.5264 22.6599 58.0089 22.7687C57.6712 22.8399 57.2299 22.809 57.2326 22.3132",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3201 19.9899C56.2929 19.9604 56.2003 19.8905 56.2779 19.5412C56.3855 19.0601 56.7655 18.9096 57.4927 18.6557C58.4788 18.3117 59.3994 18.1988 60.4086 18.2458C61.4859 18.2969 62.5727 18.2364 63.6391 18.4165C64.4304 18.5508 65.2598 18.5468 66.0579 18.6328C67.3858 18.7752 68.715 18.9459 70.0252 19.22C70.732 19.3678 71.4239 19.6715 72.1089 19.908C72.1089 19.908 72.2669 22.4046 70.6435 23.6112C70.3575 23.8235 69.5989 22.981 69.2966 22.9138C68.764 22.7942 68.2302 22.68 67.6949 22.5712C67.0099 22.4328 66.5536 22.3468 65.8699 22.6316C64.7409 23.1019 63.8066 23.2323 62.6435 22.8789C62.1165 22.719 61.7365 22.551 61.4818 22.418C61.1781 22.2594 60.839 22.1855 60.4972 22.203C60.173 22.2191 59.8502 22.2379 59.5315 22.3159C59.0181 22.4408 58.5264 22.6599 58.0089 22.7687C57.6712 22.8399 57.2299 22.809 57.2326 22.3132",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7003 18.9969C59.3516 19.0386 58.9894 19.0426 58.6462 19.1152C58.2267 19.2039 57.8086 19.3826 57.4163 19.5505C57.148 19.6661 56.8784 19.779 56.6128 19.8999C56.3867 20.002 56.1198 20.0961 55.9659 20.299C55.7739 20.5529 55.8011 20.9923 56.0667 21.1885C56.2029 21.2879 56.3854 21.3296 56.5529 21.3215",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2363 22.2151C57.2758 21.7529 57.747 21.5352 58.0344 21.3538C58.8066 20.866 60.159 20.8445 60.159 20.8445",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.891 19.7763C59.6771 19.8126 59.4647 19.8112 59.2495 19.8462C58.5331 19.9631 58.0374 20.1445 57.4313 20.5489C57.2584 20.6645 57.1017 20.8015 56.9506 20.9426C56.7994 21.0824 56.6291 21.2167 56.5161 21.3901C56.3908 21.5822 56.3758 21.7851 56.4575 21.9974C56.5719 22.293 56.7858 22.4556 57.1072 22.4046",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3713 39.7718C39.3733 41.9217 33.3808 49.1481 31.0805 46.4607C29.1452 44.1993 33.5021 41.2055 34.9511 39.5931",
    stroke: "#1A1A18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3713 39.7718C39.3733 41.9217 33.3808 49.1481 31.0805 46.4607C29.1452 44.1993 33.5021 41.2055 34.9511 39.5931",
    stroke: "#F2C850",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1415 36.5201C48.1415 36.5201 48.8974 36.4703 49.5525 36.297C50.3329 36.0914 51.4946 34.8351 50.8967 34.3325C50.5903 34.0759 50.1653 34.5959 49.2379 34.9654C48.5297 35.2476 48.0462 35.1831 47.4211 35.308C46.9662 35.3981 46.5058 35.4532 46.0414 35.4599C45.577 35.4666 45.0922 35.4975 44.7217 35.1844C44.3281 34.8512 44.1238 34.3876 44.1633 33.8165C44.1701 33.7225 44.1715 33.6284 44.1633 33.5344C44.1266 33.0009 44.3526 31.1762 43.2903 31.3952C42.0496 31.6519 42.6094 33.869 42.1409 34.6805C41.7936 35.2839 41.5798 35.7407 41.3727 36.387C41.1957 36.942 40.7422 37.071 40.3513 37.5063C39.59 38.3542 39.0139 39.1873 38.6829 39.6791C38.544 39.886 38.5154 40.148 38.6162 40.3751C38.7687 40.7204 39.0902 41.2324 39.7561 41.6987C40.2682 42.0574 40.6741 42.3154 40.9655 42.4901C41.2842 42.6822 41.6901 42.6607 41.9883 42.4377C42.5781 41.997 43.2263 41.5213 43.895 41.4339C44.3881 41.3694 44.8429 41.1719 45.3387 41.094C46.2988 40.9435 47.2249 40.445 48.1756 40.0432C48.6223 39.8551 48.7285 39.0758 48.6046 39.0381",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1415 36.5201C48.1415 36.5201 48.8974 36.4703 49.5525 36.297C50.3329 36.0914 51.4946 34.8351 50.8967 34.3325C50.5903 34.0759 50.1653 34.5959 49.2379 34.9654C48.5297 35.2476 48.0462 35.1831 47.4211 35.308C46.9662 35.3981 46.5058 35.4532 46.0414 35.4599C45.577 35.4666 45.0922 35.4975 44.7217 35.1844C44.3281 34.8512 44.1238 34.3876 44.1633 33.8165C44.1701 33.7225 44.1715 33.6284 44.1633 33.5344C44.1266 33.0009 44.3526 31.1762 43.2903 31.3952C42.0496 31.6519 42.6094 33.869 42.1409 34.6805C41.7936 35.2839 41.5798 35.7407 41.3727 36.387C41.1957 36.942 40.7422 37.071 40.3513 37.5063C39.59 38.3542 39.0139 39.1873 38.6829 39.6791C38.544 39.886 38.5154 40.148 38.6162 40.3751C38.7687 40.7204 39.0902 41.2324 39.7561 41.6987C40.2682 42.0574 40.6741 42.3154 40.9655 42.4901C41.2842 42.6822 41.6901 42.6607 41.9883 42.4377C42.5781 41.997 43.2263 41.5213 43.895 41.4339C44.3881 41.3694 44.8429 41.1719 45.3387 41.094C46.2988 40.9435 47.2249 40.445 48.1756 40.0432C48.6223 39.8551 48.7285 39.0758 48.6046 39.0381",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1377 38.0559C47.7438 37.9901 47.6334 38.0102 48.1986 37.8772C48.1986 37.8772 49.0049 37.6219 49.0594 37.3867C49.1302 37.0804 49.1588 36.6585 48.9191 36.551C48.6208 36.4166 47.6321 36.6074 47.6321 36.6074",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1377 38.0559C47.7438 37.9901 47.6334 38.0102 48.1986 37.8772C48.1986 37.8772 49.0049 37.6219 49.0594 37.3867C49.1302 37.0804 49.1588 36.6585 48.9191 36.551C48.6208 36.4166 47.6321 36.6074 47.6321 36.6074",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3896 39.1013L48.2245 38.9051C48.2245 38.9051 48.8946 38.7062 48.8959 38.5262C48.8973 38.3461 49.1397 37.8409 48.6739 37.8987",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3896 39.1013L48.2245 38.9051C48.2245 38.9051 48.8946 38.7062 48.8959 38.5262C48.8973 38.3461 49.1397 37.8409 48.6739 37.8987",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6693_11592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.4368,
    height: 206,
    fill: "white",
    transform: "translate(19 -68.0001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6693_11592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.65,
    height: 69,
    fill: "white",
    transform: "translate(20 17.9999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerHistory);
export default __webpack_public_path__ + "static/media/CareerHistory.7a8b41d4669bada3df5f52e1a0e095a3.svg";
export { ForwardRef as ReactComponent };